<template>
	<div class="QrCode" v-if="query.payType == 0 || query.payType == 2">
		<div class="QrCode_header">
			<span>
				<img src="../../../static/images/back.png" @click="goBack()">
			</span>
    		<h2>{{shopName}}</h2>
		</div>
		<div class="QrCode_content">
			<div class="content_list">
				<h4>门店</h4>
				<p>{{shopName}}</p>
			</div>
			<div class="content_list">
				<h4>桌台</h4>
				<p>{{tabName}}</p>
			</div>
			<div class="content_list">
				<h4>人数</h4>
				<p>{{eatNum}}</p>
			</div>
		</div>
		<div class="content_pay">
			<div class="pay_money">支付金额 <span>￥{{allMoney}}</span></div>
			<div class="pay_code">
				<img :src="imgSrc"/>
			</div>
			<div class="optBtn">
				<div class="pay_saoma" @click="startRecognizeFn()">扫码支付</div>
				<div class="pay_dadan" @click="preOrderFn()" v-if="isSunMi">预打单</div>
			</div>
			<div class="pay_note">
				<div></div>
				<p v-if="query.payType == 0">微信 扫码支付</p>
				<p v-else-if="query.payType == 2">支付宝 扫码支付</p>
				<p v-else>请扫描二维码进行支付</p>
				<div></div>
			</div>
			<div class="go_index" @click="goIndex()">首页</div>
			<!--<div class="opt" @click="printOrder()">打印小票</div>-->
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	import { interfaceFn } from '@/assets/util.js';
	export default{
		data () {
			return {
				name: 'QrCode',
				shopName:'',//门店名称
				tabName: '',//当前的桌台名称
				eatNum: 1,//就餐人数
				allMoney: 0,//购物车总价
				imgSrc: '',//支付二维码路径
				time: 60,//循环次数，最多5次
				timer: 18,//支付的时间
				shopInfo: {},
				payInfo: {},//支付完成的信息
				orderInfo: {},//下单返回的info
				outTradeNo: '',
				isSunMi: false,//判断是否是isSunMi
				imguri: interfaceFn(1),
				query: {},
			}
		},

		created () {
      try {
				var info = window.lee.isSunmiEquipment();
				if (info == 'true') {
					this.isSunMi = true;
				} else {
					this.isSunMi = false;
				}
			} catch (e) {
				//
			}
		},

		mounted () {
      this.init();
      window.scanCallback = this.scanCallback;//扫码
    },

		methods: {
			init: function () {
				let _this = this;
				this.shopInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));
				var logindata = JSON.parse(window.localStorage.getItem('logindata'));
				var teaFee = this.shopInfo.teaFee;
				this.tabName = this.shopInfo.title;
				this.eatNum = this.shopInfo.mealsNumbel;
				this.shopName = window.localStorage.getItem('shopName');
				var allMoney = window.localStorage.getItem('allFoodsMoney');
				this.allMoney = window.localStorage.getItem('allPrices');

				let query = this.$route.query;
				if (query && query.payMoney) {
					this.query = query;
					allMoney = query.payMoney;
					this.allMoney = query.payMoney;
					reqFn(query.payType);
				}

				// payType：0：微信支付，1：会员支付，2：支付宝
				function reqFn (payType) {
					//获取到当前的支付货币 传的是4
					let parma = {
			  			"merchantId": window.localStorage.getItem('merchantId'),
			  			"shopId": _this.shopInfo.shopId,
			  			"totalFee": allMoney*100,
			  			"orderBody": _this.shopInfo.title,
			  			"tableId": _this.shopInfo.id,
			  			"memberId": _this.$store.state.memberInfo.memberId,
		  				"employeeId": logindata.memberCode,
		  				"discountType": query.manualType,
		  				"discount": query.manual,
			  			"payType": payType
			  		}
					if (_this.$store.state.currency.payType >= 3) {
						if (_this.$store.state.currency.payType == 6) parma.moneyId = _this.$store.state.currency.id;
						parma.smallchange = _this.$store.state.currency.payType == 5 ? 0 : _this.$store.state.currency.change;
						parma.payMoney = _this.$store.state.currency.originalAmount;
					}

					let loadingInstance = _this.$loading({ fullscreen: true });
		        	_this.$http.post(interfaceFn()+'/saobei/payQRCode',
				  		qs.stringify(parma),
			            {
				            headers: {"Content-Type": "application/x-www-form-urlencoded"}
				    }).then((msg) => {
				    	let data = msg.data;
				    	_this.orderInfo = data;
				    	loadingInstance.close();
				       	if (data.returnCode == 'ok') {
				       		_this.allMoney = data.payAmount;
				       		if (payType == 0 || payType == 2) {// 显示二维码
				       			_this.imgSrc = _this.imguri + ":8088/images/" + data.qr_code;
				       			if (_this.time != -1) _this.updateFn();
				       		} else if (payType == 1 || payType == 3 || payType == 4 || payType == 5 || payType == 6) {// 会员支付完成直接打印
				       			_this.msgFn('success', data.message, 3000);
				       			_this.getPrintOrderMsgFn();
				       		}
				       	} else {
				       		_this.msgFn('warning', data.message, 3000);
				       		_this.goIndex();
				       	}

				    }).catch((error) => {
				    	loadingInstance.close();
				    	_this.goIndex();
				    	_this.msgFn('error', '获取付款码失败，请稍后重试', 3000);
					});
				}
			},

			/* 返回 */
			goBack () {
				let query = this.$route.query;
				if (query.isFirstNum == 1) {
					this.tableOperate(1);
				} else {
					this.$router.push({path: "/pay"});
					//this.$router.go(-1);
				};
				this.time = -1;
			},

			/* 返回首页 */
			goIndex () {
				this.tableOperate(1);
				this.time = -1;
			},

			// 桌台操作解锁
			tableOperate (n) {
				let num = 1;
				var curClickInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));//获取当前点击的桌台信息
				let cartInfo = window.localStorage.getItem('cartInfo');
				if (cartInfo) {
					cartInfo = JSON.parse(cartInfo);
					num = cartInfo.orderInfo.mealsNumber;
				}
				let info = {
					shopId: window.localStorage.getItem('shopId'),
              		tableId: curClickInfo.id,
              		userId: JSON.parse(window.localStorage.getItem('userInfo')).id,
              		operate: 2,// 0：单纯开台不点餐，1：锁台，2：解锁,3:清台
              		remark: '解锁',
              		mealsNumber: num,
				}
				let loadingInstance = this.$loading({ fullscreen: true });
				this.$http.post(interfaceFn()+'/shopTable/tableOperate',
		  		qs.stringify(info),
	            	{
		            	headers: {"Content-Type": "application/x-www-form-urlencoded"}
		        }).then((res) => {
		        	loadingInstance.close();
		        	if (n == 1) {
		        		this.$router.push({path: "/home"});
		        	} else if (n == 2) {
		        		this.$router.push({path: "/"});
		        	}
		        }).catch(() => {
			    	loadingInstance.close();
			    	if (n == 1) {
		        		this.$router.push({path: "/home"});
		        	} else if (n == 2) {
		        		this.$router.push({path: "/"});
		        	}
			    });
			},

			/* 顾客扫码时时更新判断是否是付款成功 */
			updateFn () {
				if (this.time > 0) {
					this.time--;
					this.getPrintOrderMsgFn();
				} else if (this.time == 0 && this.payInfo.returnCode == 'error') {
					this.init();
					this.time = 60;
					this.msgFn('error', '二维码已失效，请重新扫描', 3000);
				} else if (this.time == -1) {
					return;
				}
				return;
			},

			/* 获取打印的参数 */
			getPrintOrderMsgFn () {
				if (this.timer == -1) return;
//				let loadingInstance = this.$loading({ fullscreen: true });
				this.$http.post(interfaceFn()+'/orderMessage/printOrderMsg',
			  		qs.stringify({
			  			"waimaiId": this.orderInfo.waimaiId,
			  			"shopId": this.shopInfo.shopId
			  		}),
		            {
			            headers: {"Content-Type": "application/x-www-form-urlencoded"}
			    }).then((info) => {
//			    	loadingInstance.close();
			       	this.payInfo = info.data;
			       	if (info.data.returnCode == 'error') {
				       	setTimeout(() => {
			          		this.updateFn()//自循环
			          	}, 3000);
			       	} else {
			       		this.time = -1;
			       		this.printOrder();// 执行打印
			       		this.tableOperate(2);// 解锁
			          	return;
			       	};
			    }).catch(() => {
//			    	loadingInstance.close();
			    });
			},

			/* 付款成功后进行打印 */
			printOrder: function () {
				var printInfo = this.payInfo.returnCode == 'ok' ? this.payInfo.printInfo : '';
				if (!this.isSunMi) return;
				try {
					javascript:lee.printOrder(JSON.stringify(printInfo));
				} catch (e) {
					this.msgFn('error', e, 3000);
				}
			},

			/* 扫码支付按钮调用摄像头 */
			startRecognizeFn: function () {
				this.time = -1;
				this.timer = 18;
				try {
					javascript:lee.scanQRCode();
				} catch (e) {
					this.msgFn('error', e, 3000);
				}
			},

			/* 扫码成功后的回调 */
			scanCallback: function (type, value) {
				var logindata = JSON.parse(window.localStorage.getItem('logindata'));
		        this.$http.post(interfaceFn()+'/saobei/barCodePayment', qs.stringify({
		  			"merchantId": this.shopInfo.merchantId,
		  			"shopId": this.shopInfo.shopId,
		  			"tableId": this.shopInfo.id,
		  			"employeeId": logindata.memberCode,
		  			"authNo": value
		  		}), {
			        headers: {"Content-Type": "application/x-www-form-urlencoded"}
			    }).then((info) => {
			    	let data = info.data;
			    	this.outTradeNo = data.outTradeNo;
			    	if (data.returnCode == 'ok') {
				        this.getPrintOrderMsgFn();

				    } else if (data.returnCode == 'error') {
				    	this.returnFn();

				    } else if (data.returnCode == 'fal') {
				    	this.searchFn();

				    }
			    });
			},

			/* 查询 */
			searchFn () {
				var logindata = JSON.parse(window.localStorage.getItem('logindata'));
				/* 查询支付信息 */
		    	this.$http.post(interfaceFn()+'/saobei/paymentQuery',
			  		qs.stringify({
			  			"merchantId": this.shopInfo.merchantId,
			  			"shopId": this.shopInfo.shopId,
			  			"tableId": this.shopInfo.id,
			  			"employeeId": logindata.memberCode,
			  			"outTradeNo": this.outTradeNo
			  		}),
		            {
			            headers: {"Content-Type": "application/x-www-form-urlencoded"}
			    }).then((msg) => {
			        if (msg.data.returnCode == 'ok') {
			        	this.msgFn('success', msg.data.message, 3000);
				        this.getPrintOrderMsgFn();
			        	this.timer = -1;
				        return;
			        } else if (msg.data.returnCode == 'error') {
			        	this.returnFn();
			        	this.timer = -1;
			        } else if (msg.data.returnCode == 'fal') {
			        	this.countDown();
			        }
			    });
			},

			/* 查询轮循 */
			countDown: function () {
		        if (this.timer > 0) {
		          	this.timer--;
		          	setTimeout(() => {
		          		this.searchFn();
		          	}, 1000);

		        } else if (this.timer == -1) {
		        	return;
		        } else {
		        	this.returnFn();
		        	this.timer = -1;
		        	return;
		        }
		   	},

			/* 撤销退款 */
			returnFn () {
				/* 失败执行撤销支付 */
		    	this.$http.post(interfaceFn()+'/saobei/paymentCancel',
			  		qs.stringify({
			  			"merchantId": this.shopInfo.merchantId,
			  			"shopId": this.shopInfo.shopId,
			  			"tableId": this.shopInfo.id,
			  			"outTradeNo": this.outTradeNo
			  		}),
		            {
			            headers: {"Content-Type": "application/x-www-form-urlencoded"}
			    }).then((msg) => {
			    	this.msgFn('info', msg.data.message, 3000);
			        /*setTimeout(function () {
		          		_this.$router.push({path: "/"});
		          	}, 3000);*/
			    });
			},

			/* 预打单 */
			preOrderFn () {
				this.$http.post(interfaceFn()+'/orderMessage/prePrintOrderMsg',
			  		qs.stringify({
			  			"shopId": this.shopInfo.shopId,
			  			"waimaiId": this.orderInfo.waimaiId
			  		}),
		            {
			            headers: {"Content-Type": "application/x-www-form-urlencoded"}
			    }).then((msg) => {
			    	if (msg.data.returnCode == 'ok') {
			    		javascript:lee.preOrderPrint(JSON.stringify(msg.data.printInfo));
			    	} else {
			    		this.msgFn('error', '获取打印数据失败，请稍后重试', 3000);
			    	}
			    });
			},

			// 提示
			msgFn (type, msg, time) {
				this.$Message({
		        	duration: time,
		            message: msg,
		            center: true,
		            type: type
		        });
			},
		}
	}
</script>

<style scoped>
	@import "../../../static/css/QrCode.css";
</style>



// WEBPACK FOOTER //
// src/components/home/QrCode.vue